import { apiClient } from '@src/services/http-common'
import { Customer } from '@src/types/customer'
import { useQuery } from '@tanstack/react-query'

const getCustomer = async (customerId: number) => {
  const response = await apiClient.get<Customer>(`/Customers/${customerId}`)
  return response.data
}

export const useGetCustomer = (customerId?: number) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['customers', customerId],
    queryFn: () => getCustomer(customerId!),
    enabled: !!customerId,
  })

  return [data, isLoading, error] as const
}
